import React from "react";
import ReactQRCode from "react-qr-code";

export function QRCode({ value, ...props }) {
  return <ReactQRCode value={value} {...props} />;
}
